module.exports = {
	FCM_SERVER_KEY: 'AIzaSyBaX4HQJawqKFa8SzgJ0483OeK3w9iew6w',
	FCM_SERVER_URL: 'https://fcm.googleapis.com/fcm/send',
	VALID_IMG_TYPES: [ 'image/jpg', 'image/jpeg', 'image/gif', 'image/png' ],
	orderStatus: {
		INCOMPLETE: 1, //El cliente aun no la termina
		NEW: 2, //El cliente ya la confirmo
		IN_REPART: 3, //En reparto
		SHIPPED: 4, //En camino
		ARRAIVED: 5, //LLego al cliente
		RECIVED: 6, //Se marca como recivida en el dashboard
		CANCELED: 10, //Cancelada
		ALSO_INCOMPLETE: 11,
		TEST: 20,
		CONFIRMED_BY_COMPANY: 12
	},
	productStatus: {
		NEW: 1,
		MODIFIED: 2,
		DELETED: 6
	},
	companyStatus: {
		ACTIVE: 1,
		INACTIVE: 0
	},
	ONE_MEGABYTE: 1000000,
	DATE_FORMAT: 'hh:mm a DD/MM/YYYY',
	ORDERS_PARENT_COLLECTION: 'BranchOffices',
	APP_VERSION: '1.1.7',
	userRoles: {
		ADMIN: 'admin',
		COMERCE: 'comerce',
		DELIVERY: 'delivery'
	},
	driverRoles: {
		DRIVER: 'driver',
		COLLECTOR: 'collector'
	},
	driverStatus: {
		INACTIVE: 0,
		AVAILABLE: 1,
		BUSY: 2,
		UNAVAILABLE: 3
	},
	orderPaymentTypes: {
		STRIPE: 1,
		TRANSFER: 2
	},
	posibleOrderStatus: ['Recibida', 'Lista para entregar', 'Entregada']
};
